<template>
  <div class="wholeContext">
    <app-sidebar></app-sidebar>
    <app-header :transDataSet="transDate"></app-header>
    <div class="appContext">
      <div class="container">
        <div class="area_wrap">
          <div class="board_wrap">
            <div class="bw_item" v-for="s in getSurgeryReviewList" :key="s.code" @click.prevent="goDetail(s.code)">
              <div class="bw_title">
                <h2 v-text="s.title">구강암 수술</h2>
                <p class="date">{{s.date | moment('YYYY.MM.DD')}}</p>
              </div>
              <div class="bw_imgWrap">
                <img :src="'https://api.thanq.kr' + s.thumbnail">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <add-popup v-if="checkPopup"
               :popupSet="popupSet"/>
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader'
import AppSidebar from '@/components/AppSidebar'
import AddPopup from '@/components/AddPopup'
import errorParser from '@/utils/error-parser'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
export default {
  data () {
    return {
      popupSet: {
        title: '',
        modalImg: 'alert_cn.svg',
        content: '',
        confirmBtnText: '확인',
        count: 'single',
        closeType: 'close'
      },
      transDate: {
        headerName: '수술후기',
        prevUrl: '/'
      },
      setCount: false
    }
  },
  computed: {
    ...mapGetters('surgery', [
      'getSurgeryReviewList'
    ]),
    ...mapState([
      'checkPopup'
    ])
  },
  methods: {
    ...mapMutations([
      'SET_POPUP'
    ]),
    ...mapActions('surgery', [
      'SURGERY_REVIEW_LIST',
      'SURGERY_REVIEW'
    ]),
    async goDetail (code) {
      try {
        await this.SURGERY_REVIEW(code)
          .then(() => {
            this.$router.push(`/surgery/surgeryReview/${code}`)
          })
      } catch (error) {
        console.log('error :', error);
        console.log('수술후기 리스트- 디테일로 이동하는 api에서 에러발생')
        if (error.status !== 401) {
          this.SET_POPUP(true)
          this.popupSet.content = errorParser.parse(error)
        } else {
          await this.$router.push('/login')
        }
      } finally {

      }
    },
    async fetchData () {
      try {
        await this.SURGERY_REVIEW_LIST()
      } catch (error) {
        console.log('error :', error);
        console.log('수술후기 리스트 api에서 에러발생.')
        if (error.status !== 401) {
          this.SET_POPUP(true)
          this.popupSet.content = errorParser.parse(error)
        } else {
          await this.$router.push('/login')
        }
      } finally {
      }
    },
    callPrev () {
      if (this.setCount) {
        this.$router.push('/')
      } else {
        history.go(1)
      }
      this.setCount = true
      // 클로즈 함수 구현
    }
  },
  components: {
    AppHeader,
    AppSidebar,
    AddPopup
  },
  created () {
    if (history.pushState !== undefined) {
      history.pushState({}, '', location.href)
      window.onpopstate = () => {
        this.callPrev()
      }
    }
    this.fetchData()
  },
  beforeDestroy () {
    this.SET_POPUP(false)
    this.setCount = false
  }
}
</script>

<style lang="scss" scoped>
</style>
